import { parseGuidanceSections } from "../utils/guidanceSections";

/**
 * Lays out eligibility guidance copy as discrete labelled blocks instead of
 * one run-on paragraph. Unlabelled copy renders as a plain sentence, so
 * single-sentence tips are unchanged.
 */
const GuidanceSections = ({
  text,
  className = "",
}: {
  text?: string | null;
  className?: string;
}) => {
  const sections = parseGuidanceSections(text);
  if (sections.length === 0) return null;

  return (
    <div className={`flex flex-col gap-3 text-left ${className}`}>
      {sections.map((section, index) => (
        <div key={`${section.label ?? "text"}-${index}`}>
          {section.label && (
            <div className="text-[11px] font-bold uppercase tracking-[0.06em] text-[#8A6A45] mb-1">
              {section.label}
            </div>
          )}
          <p className="text-[15px] leading-[22px] text-[#1B365D] m-0">
            {section.body}
          </p>
        </div>
      ))}
    </div>
  );
};

export default GuidanceSections;
